export enum ResetBlockCode {
  NOT_RESETTABLE = "NOT_RESETTABLE",
  INVALID_STEP = "INVALID_STEP",
  SHOPIFY_RETURN_PROCESSED = "SHOPIFY_RETURN_PROCESSED",
  SHOPIFY_RETURN_NOT_CANCELLABLE = "SHOPIFY_RETURN_NOT_CANCELLABLE",
}

export interface ResetBlock {
  code: ResetBlockCode;
  message: string;
  shopifyReturnName?: string;
}

export function notResettableBlock(reason: string): ResetBlock {
  return { code: ResetBlockCode.NOT_RESETTABLE, message: reason };
}

export const invalidStepBlock: ResetBlock = {
  code: ResetBlockCode.INVALID_STEP,
  message:
    "The reset point isn't a step customers can start from in the current flow. Choose a different reset point.",
};

export function shopifyReturnProcessedBlock(
  shopifyReturnName: string,
): ResetBlock {
  return {
    code: ResetBlockCode.SHOPIFY_RETURN_PROCESSED,
    message: `Shopify return ${shopifyReturnName} has items Shopify already processed or refunded. Cancel or refund it in Shopify, then reset.`,
    shopifyReturnName,
  };
}

export function shopifyReturnNotCancellableBlock(
  shopifyReturnName: string,
): ResetBlock {
  return {
    code: ResetBlockCode.SHOPIFY_RETURN_NOT_CANCELLABLE,
    message: `Shopify wouldn't cancel return ${shopifyReturnName}. Cancel or close it in Shopify, then reset.`,
    shopifyReturnName,
  };
}

/** Raised before a reset changes anything, so nothing is left half-applied. */
export class ResetBlockedError extends Error {
  override name = "ResetBlockedError";
  readonly block: ResetBlock;

  constructor(block: ResetBlock) {
    super(block.message);
    this.block = block;
  }
}
